/*!

=========================================================
* Argon Dashboard React - v1.2.1
=========================================================

* Product Page: https://www.creative-tim.com/product/argon-dashboard-react
* Copyright 2021 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/argon-dashboard-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import ReactDOM from "react-dom";

import "assets/plugins/nucleo/css/nucleo.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "assets/scss/argon-dashboard-react.scss";
import "assets/scss/main.scss";
import "react-toastify/dist/ReactToastify.css";

import App from "App";
import { Provider } from "react-redux";
import store from "store";
import { ToastContainer } from "react-toastify";

ReactDOM.render(
  <Provider store={store}>
    <App />,
    <ToastContainer />
  </Provider>,
  document.getElementById("root")
);
